import React from 'react';
import RegistrationFormProps from '../registration.types';
import FormControl from '@material-ui/core/FormControl';
import AccountSection from '../AccountSection';
import UserAccountSection from '../UserAccountSection';
import AccountTypeToggle from '../AccountTypeToggle';
import Divider from '@material-ui/core/Divider';

interface AccountInformationProps extends RegistrationFormProps {
  classes: any;
}

const AccountInformation = (props: AccountInformationProps) => {
  const { classes, form } = props;

  return (
    <FormControl
      component={'fieldset'}
      style={{ width: '100%', margin: '0 0 12px 0' }}
    >
      <AccountTypeToggle {...props} />

      <Divider css={{ marginBottom: '24px !important' }} />

      <AccountSection {...props} classes={classes} />

      <Divider css={{ margin: '24px 0 !important' }} />

      <UserAccountSection {...props} classes={classes} />
    </FormControl>
  );
};

export default AccountInformation;
